if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        const etaLabel = this.getActiveEtaLabel();
        if (etaLabel) {
          this.confirmEta(etaLabel).then((confirmed) => {
            if (confirmed) this.addToCart();
          });
          return;
        }

        this.addToCart();
      }

      getActiveEtaLabel() {
        const variantId = String(this.variantIdInput?.value || '');
        const map =
          typeof product_variant_inventory_policy_eta_date !== 'undefined'
            ? product_variant_inventory_policy_eta_date
            : null;

        if (map && variantId && map[variantId]) {
          const info = map[variantId];
          if (Number(info.inventory_quantity) > 0) return null;
          if (info.date instanceof Date && !Number.isNaN(info.date.getTime())) {
            return info.date.toLocaleDateString('nl-NL', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            });
          }
        }

        const dataEta = (this.dataset.etaDate || '').trim();
        if (dataEta) {
          const dataQty = Number(this.dataset.etaQty || '0');
          if (dataQty > 0) return null;
          const parsed = new Date(dataEta);
          if (!Number.isNaN(parsed.getTime())) {
            return parsed.toLocaleDateString('nl-NL', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            });
          }
          return dataEta;
        }

        const root = this.closest('.product') || document;
        const etaBox = root.querySelector('.product-variant-inventory-policy-eta-date');
        if (!etaBox || etaBox.hidden) return null;
        if (getComputedStyle(etaBox).display === 'none') return null;
        const etaText = (etaBox.querySelector('.eta-date')?.textContent || '').trim();
        return etaText || null;
      }

      confirmEta(etaLabel) {
        return new Promise((resolve) => {
          const existing = document.getElementById('KtmEtaConfirm');
          if (existing) existing.remove();

          const overlay = document.createElement('div');
          overlay.id = 'KtmEtaConfirm';
          overlay.className = 'ktm-eta-confirm';
          overlay.setAttribute('role', 'dialog');
          overlay.setAttribute('aria-modal', 'true');
          overlay.setAttribute('aria-labelledby', 'KtmEtaConfirmTitle');
          overlay.innerHTML =
            '<div class="ktm-eta-confirm__dialog">' +
            '<h2 id="KtmEtaConfirmTitle" class="ktm-eta-confirm__title">LET OP: Levertijd</h2>' +
            '<p class="ktm-eta-confirm__text">Dit product is pas leverbaar vanaf <strong></strong>.</p>' +
            '<div class="ktm-eta-confirm__actions">' +
            '<button type="button" class="ktm-eta-confirm__btn ktm-eta-confirm__btn--secondary" data-eta-cancel>Annuleren</button>' +
            '<button type="button" class="ktm-eta-confirm__btn ktm-eta-confirm__btn--primary" data-eta-confirm>Toch bestellen en naleveren</button>' +
            '</div></div>';

          overlay.querySelector('.ktm-eta-confirm__text strong').textContent = etaLabel;

          const finish = (confirmed) => {
            document.removeEventListener('keydown', onKey);
            overlay.remove();
            resolve(confirmed);
          };

          const onKey = (event) => {
            if (event.key === 'Escape') finish(false);
          };

          overlay.addEventListener('click', (event) => {
            if (event.target === overlay) finish(false);
          });
          overlay.querySelector('[data-eta-cancel]').addEventListener('click', () => finish(false));
          overlay.querySelector('[data-eta-confirm]').addEventListener('click', () => finish(true));
          document.addEventListener('keydown', onKey);

          document.body.appendChild(overlay);
          overlay.querySelector('[data-eta-confirm]').focus();
        });
      }

      addToCart() {
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
